/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Secret } from '../../models/secret';

export interface AccountControllerGetSecrets$Params {
  accountId: string;
}

export function accountControllerGetSecrets(http: HttpClient, rootUrl: string, params: AccountControllerGetSecrets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Secret>>> {
  const rb = new RequestBuilder(rootUrl, accountControllerGetSecrets.PATH, 'get');
  if (params) {
    rb.path('accountId', params.accountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Secret>>;
    })
  );
}

accountControllerGetSecrets.PATH = '/account/{accountId}/secrets';
